import EventEmitter from "events";
import React from "react";

export class CartControl extends EventEmitter { 
    onRefreshCart(cb: () => void) { this.on("refreshCart", cb); }
    offRefreshCart(cb: () => void) { this.removeListener("refreshCart", cb); }
    refreshCart() { this.emit("refreshCart"); }
}

export class CartControlContextClass { 
    cartControl: CartControl;

    constructor() {
        this.cartControl = new CartControl();
    }
}

export const CartControlContextInstance = new CartControlContextClass();

export const CartControlContext = React.createContext<CartControlContextClass>(CartControlContextInstance);


